// Module-scoped endpoint paths for the secondary market (investor-service
// `/api/marketplace`). `{…}` placeholders are filled by the endpoint functions.

export const TRADING_ENDPOINTS = {
  // Browse (1.7.2)
  PROPERTIES: '/api/marketplace/properties',
  PROPERTY_DETAIL: '/api/marketplace/properties/{propertyId}',
  PROPERTY_LISTINGS: '/api/marketplace/properties/{propertyId}/listings',
  LISTING_DETAIL: '/api/marketplace/listings/{listingId}',
  // Buy (1.7.5)
  BUY_QUOTE: '/api/marketplace/listings/{listingId}/buy-quote',
  ORDERS: '/api/marketplace/orders',
  ORDER_DETAIL: '/api/marketplace/orders/{orderId}',
  CANCEL_ORDER: '/api/marketplace/orders/{orderId}/cancel',
  // Sell (1.7.3)
  SELL_OVERVIEW: '/api/marketplace/holdings/{propertyId}/sell-overview',
  SELL_QUOTE: '/api/marketplace/holdings/{propertyId}/sell-quote',
  LISTINGS: '/api/marketplace/listings',
  // My listings (1.7.4)
  MY_LISTINGS: '/api/marketplace/my-listings',
  MY_LISTING_DETAIL: '/api/marketplace/my-listings/{listingId}',
  CANCEL_MY_LISTING: '/api/marketplace/my-listings/{listingId}/cancel',
  RENEW_MY_LISTING: '/api/marketplace/my-listings/{listingId}/renew',
} as const
